import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, HostListener, Inject, NgModule, Optional, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { Constants } from '@app/common/constants';
import { LinkModule } from '@app/directives/link.directive';
import { FeatureSettingsStoreService } from '@app/services/feature-settings-store.service';

@Component({
  selector: 'app-ios-pwa-banner',
  templateUrl: './ios-pwa-banner.component.html',
  styleUrls: ['./ios-pwa-banner.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class IosPwaBannerComponent {

  workplaceName = this.featureSettingsStoreService.state.workplaceName;
  title = this.featureSettingsStoreService.state.title;

  constructor(
    @Optional() private dialogRef: MatDialogRef<IosPwaBannerComponent>,
    @Inject(DOCUMENT) private document: Document,
    private featureSettingsStoreService: FeatureSettingsStoreService) { }

  close() {
    if (this.dialogRef) {
      this.document.cookie = Constants.IOS_BANNER_CLOSED_COOKIE;
      this.dialogRef.close(true);
    }
  }

  @HostListener('document:click', ['$event']) public onClickAnyWhere() {
    this.close();
  }
}
@NgModule({
  declarations: [IosPwaBannerComponent],
  entryComponents: [IosPwaBannerComponent],
  imports: [
    CommonModule,
    LinkModule,
    MatButtonModule
  ]
})
export class IosPwaBannerModule { }
